import React from 'react'
import HeroSection from "./HeroSection.jsx"
import Navber from './Navber.jsx'
import CardSlider from './CardSlider.jsx'
import PremierServices from "./PremierServices.jsx"
import OurClientSay from "./OurClientCarousel.jsx"
import Footer from "./Footer.jsx"


function HomeMain() {
  return (
    <div>
        <Navber/>
        <HeroSection/>
        <CardSlider/>
        <PremierServices/>
        <OurClientSay/>
        <Footer/>
    </div>
  )
}

export default HomeMain